import React from 'react';

// Modifiers
import addGif from '../modifiers/addGif';

// Types
import { GifData, GifPluginStore } from '../gifPlugin';

// Components
import { WpGifPicker } from '../../../../gif';
import GifPickerDropdownPopover from './GifPickerDropdownPopover';
import { Portal } from '../../../../portal/Portal';
import WpBackdrop from '../../../../backdrop/WpBackdrop';

export interface GifPickerDropdownPubProps {
  open?: boolean;
  onOpenChange?: Function;
  gifPickerRef: React.Ref<HTMLDivElement>;
}

export interface GifPickerDropdownProps extends GifPickerDropdownPubProps {
  store: GifPluginStore;
}

const GifPickerDropdown = ({ open, onOpenChange, gifPickerRef, store }: GifPickerDropdownProps) => {
  if (!open) return null;

  const handleGifSelect = (gif: GifData) => {
    const newEditorState = addGif(store.getEditorState!(), gif);
    store.setEditorState!(newEditorState);
    onOpenChange(false);
  };

  const handleDismissOnBackdrop = () => {
    onOpenChange();
  };

  return (
    <Portal idPrefix="GifPickerDropdown">
      <GifPickerDropdownPopover gifPickerRef={gifPickerRef}>
        <div onClick={e => e.stopPropagation()}>
          <WpGifPicker onSelect={handleGifSelect} />
        </div>
      </GifPickerDropdownPopover>
      <WpBackdrop onClick={handleDismissOnBackdrop} transparent />
    </Portal>
  );
};

export default GifPickerDropdown;
